export default __webpack_public_path__ + "static/texture-otis-redding-2b85ae8ffa43b57da681a8c963875464.png";